function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import Segment from "semantic-ui-react/dist/es/elements/Segment/Segment.js";
import { Divider } from "../../elements/Divider";
import { FlexContainer } from "../../layout/FlexContainer";
import { Heading } from "../../typography/Heading";
import { Paragraph } from "../../typography/Paragraph";
import { Range } from "../../inputs/Range";
export var Component = function Component(_ref) {
  var description = _ref.description,
      heading = _ref.heading,
      rangeProps = _objectWithoutProperties(_ref, ["description", "heading"]);

  return React.createElement(Segment, {
    className: "is-input-segment",
    vertical: true
  }, React.createElement(FlexContainer, {
    alignItems: "baseline",
    flexDirection: "column",
    justifyContent: "space-between"
  }, React.createElement(Heading, null, heading), React.createElement(Paragraph, null, description), React.createElement(Divider, {
    size: "small"
  }), React.createElement(Range, rangeProps)));
};
Component.displayName = 'RangeInputSegment';
Component.defaultProps = {
  domain: [0, 100],
  initialValue: undefined,
  isShowingTrackOutsideLeft: true,
  isShowingTrackOutsideRight: false,
  name: '',
  onChange: Function.prototype,
  renderValue: function renderValue(value) {
    return value;
  },
  step: 1,
  value: undefined
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  description: PropTypes.string.isRequired,
  domain: PropTypes.arrayOf(PropTypes.number),
  heading: PropTypes.string.isRequired,
  initialValue: PropTypes.arrayOf(PropTypes.number),
  isShowingTrackOutsideLeft: PropTypes.bool,
  isShowingTrackOutsideRight: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  renderValue: PropTypes.func,
  step: PropTypes.number,
  value: PropTypes.arrayOf(PropTypes.number)
} : {};